import { useState } from "react";
import { Star } from "lucide-react";
import { toast } from "sonner";
import { api, img, errMsg } from "../lib/api";
import { Textarea } from "./ui/textarea";
import VideoField from "./VideoField";

export default function ReviewForm({ pid, onDone }) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [busy, setBusy] = useState(false);
  const upload = async (files) => {
    for (const f of [...files].slice(0, 5 - photos.length)) {
      try { const fd = new FormData(); fd.append("file", f); const r = await api.post("/reviews/upload", fd); setPhotos((x) => [...x, r.data.url]); }
      catch (e) { toast.error(errMsg(e)); }
    }
  };
  const submit = async () => {
    setBusy(true);
    try { await api.post(`/products/${pid}/reviews`, { rating, comment, photos, videos }); toast.success("Thanks! Your review is posted"); onDone(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl bg-[#12141c] border border-white/10 p-5 space-y-3" data-testid="review-form">
      <div className="flex gap-1">{[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" data-testid={`review-star-${n}`} onClick={() => setRating(n)}><Star size={24} className={n <= rating ? "fill-[#ffb703] text-[#ffb703]" : "text-slate-600"} /></button>
      ))}</div>
      <Textarea data-testid="review-comment-input" value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Share your experience..." />
      <div className="flex flex-wrap gap-2 items-center">
        {photos.map((u) => <img key={u} src={img(u)} alt="" className="w-16 h-16 rounded-lg object-cover" />)}
        {photos.length < 5 && <label className="w-16 h-16 rounded-lg border border-dashed border-white/20 grid place-items-center text-[10px] text-slate-400 cursor-pointer text-center">+ Photo<input data-testid="review-photo-input" type="file" accept="image/jpeg,image/png,image/webp" multiple hidden onChange={(e) => upload(e.target.files)} /></label>}
      </div>
      <VideoField videos={videos} setVideos={setVideos} max={2} testid="review-video" />
      <p className="text-[11px] text-slate-500">You can review each product only once.</p>
      <button type="button" data-testid="review-submit-button" disabled={comment.trim().length < 3 || busy} onClick={submit} className="px-5 py-2 rounded-full bg-[#ff5500] font-semibold disabled:opacity-40">{busy ? "Posting..." : "Post review"}</button>
    </div>
  );
}
